var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSynapseInactive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.357 8.429a2.214 2.214 0 1 0 0-4.429 2.214 2.214 0 0 0 0 4.429m0 1a3.214 3.214 0 1 0-1.755-.522l-.625 1.874a5.143 5.143 0 1 0 4.304 5.309l1.303.13a3.214 3.214 0 1 0 .244-.98l-1.6-.16A5.15 5.15 0 0 0 9.837 11h.12l.56-1.682q.404.109.84.11Zm6.429 9.286a2.214 2.214 0 1 0 0-4.43 2.214 2.214 0 0 0 0 4.43m-5.5-2.858a4.143 4.143 0 1 1-8.286 0 4.143 4.143 0 0 1 8.286 0",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSynapseInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/synapse-inactive.74cb999f.svg";